import { render, staticRenderFns } from "./WarmingTraysOverlay.vue?vue&type=template&id=97a48cfc&scoped=true"
import script from "./WarmingTraysOverlay.vue?vue&type=script&lang=js"
export * from "./WarmingTraysOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a48cfc",
  null
  
)

export default component.exports